import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import ModuleTabs from '@/components/ModuleTabs';
import './DashboardPage.css';

const DashboardPage: React.FC = () => {
  const { logout } = useAuth();

  return (
    <div className="dashboard-container">
      <main className="dashboard-content">
        <ModuleTabs onLogout={logout} />
      </main>
    </div>
  );
};

export default DashboardPage;
